import { useEffect } from "react";
import api from "../../config";

export default function ProductInput({filters, setFilters, products, setProducts, selectProduct}){
    function getProducts(filter){
        if(filter?.length >= 3){
          api
          .get("/api/products/getSearchProduct?term=" + filter.split('-')[0].trim())
          .then((response) => {
            let datas = [];
    
            response.data?.list?.map((product, index) => {
              product.label = product.codigo_produto + ' - ' + product.descricao;
              product.value = product.codigo_produto;
                
              datas.push(product)
            });
    
            if(filter === filters.produto.split('-')[0].trim()){
              setProducts(datas);
            }
          })
          .catch((error) => {
            console.log(error)
          });
        }
    }

    useEffect(() => {
        getProducts(filters.produto);
    }, [filters.produto]);

    return (
        <div className="formDiv">
            <label>Produto</label><br/>
            <input type="text" placeholder="Produto" value={filters.produto} style={{height: '37.5px'}} onChange={(e) => {setFilters((prevState) => ({...prevState, produto: e.target.value})); setProducts([])}} maxLength="60"/>
            <ul className="dropdown-menu" id="transportDatalist">
                {products?.map((item, index) => {
                    return (
                        <li key={index} onClick={() => {setFilters((prevState) => ({...prevState, produto: `${item.codigo_produto} - ${item.descricao}`})); setProducts([]); selectProduct(item)}}>
                        <a>{`${item.codigo_produto} - ${item.descricao}`}</a>
                        </li>
                )})}
            </ul>
        </div>
    )
}